 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AssetMaster":"AssetMaster","Client~Updates~Vendors":"Client~Updates~Vendors","Client~Vendors":"Client~Vendors","Client":"Client","Employees~Projects~Settings":"Employees~Projects~Settings","Employees":"Employees","Projects~Tags":"Projects~Tags","Projects":"Projects","Settings":"Settings","GoogleCalendarIntegrationComponent":"GoogleCalendarIntegrationComponent","Holidays":"Holidays","MenuManager":"MenuManager","PageManager":"PageManager","PrayTube":"PrayTube","Tags":"Tags","ScriptManager":"ScriptManager","Status":"Status","VueGridLayout":"VueGridLayout","assetDepreciation":"assetDepreciation","assetManager":"assetManager","Vendors":"Vendors","ClockWork~performance":"ClockWork~performance","ClockWork":"ClockWork","Designation":"Designation","Role":"Role","performance":"performance","Updates":"Updates"}[chunkId]||chunkId) + "." + {"AssetMaster":"331a7c15","Client~Updates~Vendors":"3fa8c0c7","Client~Vendors":"bdbd35bd","Client":"03054745","Employees~Projects~Settings":"5d65c3b7","Employees":"c918edec","Projects~Tags":"983cb5cd","Projects":"557c2ea5","Settings":"84179ca3","GoogleCalendarIntegrationComponent":"2b1ba34c","Holidays":"0a4c52bf","MenuManager":"8ad91382","PageManager":"44121903","PrayTube":"7f4cf14c","Tags":"d472ff51","ScriptManager":"1e17842b","Status":"179e1a81","VueGridLayout":"3c8d02c2","assetDepreciation":"ad8a2041","assetManager":"5e013c47","chunk-19b8ea6f":"53ee3998","Vendors":"71a458fd","ClockWork~performance":"4deddf49","ClockWork":"3604ca56","Designation":"d5cd4bf2","Role":"0fe56e73","chunk-34cb6d8e":"07ca2591","chunk-c8fd8f6a":"9a0d3c4c","performance":"5259b569","chunk-31fe34e9":"125f7382","chunk-2d2302c4":"185db983","Updates":"c738fe07"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AssetMaster":1,"Client":1,"Employees":1,"Projects~Tags":1,"Projects":1,"Settings":1,"Holidays":1,"PrayTube":1,"Tags":1,"VueGridLayout":1,"assetDepreciation":1,"Vendors":1,"ClockWork~performance":1,"ClockWork":1,"Role":1,"chunk-34cb6d8e":1,"chunk-c8fd8f6a":1,"performance":1,"chunk-31fe34e9":1,"Updates":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AssetMaster":"AssetMaster","Client~Updates~Vendors":"Client~Updates~Vendors","Client~Vendors":"Client~Vendors","Client":"Client","Employees~Projects~Settings":"Employees~Projects~Settings","Employees":"Employees","Projects~Tags":"Projects~Tags","Projects":"Projects","Settings":"Settings","GoogleCalendarIntegrationComponent":"GoogleCalendarIntegrationComponent","Holidays":"Holidays","MenuManager":"MenuManager","PageManager":"PageManager","PrayTube":"PrayTube","Tags":"Tags","ScriptManager":"ScriptManager","Status":"Status","VueGridLayout":"VueGridLayout","assetDepreciation":"assetDepreciation","assetManager":"assetManager","Vendors":"Vendors","ClockWork~performance":"ClockWork~performance","ClockWork":"ClockWork","Designation":"Designation","Role":"Role","performance":"performance","Updates":"Updates"}[chunkId]||chunkId) + "." + {"AssetMaster":"37060725","Client~Updates~Vendors":"31d6cfe0","Client~Vendors":"31d6cfe0","Client":"7915fdd5","Employees~Projects~Settings":"31d6cfe0","Employees":"876be744","Projects~Tags":"8548928c","Projects":"aab5ac06","Settings":"52adffef","GoogleCalendarIntegrationComponent":"31d6cfe0","Holidays":"c0aea84c","MenuManager":"31d6cfe0","PageManager":"31d6cfe0","PrayTube":"17d7bce3","Tags":"401fe972","ScriptManager":"31d6cfe0","Status":"31d6cfe0","VueGridLayout":"8d1094a8","assetDepreciation":"bc5099b6","assetManager":"31d6cfe0","chunk-19b8ea6f":"31d6cfe0","Vendors":"652be7e1","ClockWork~performance":"866029f2","ClockWork":"28d189ef","Designation":"31d6cfe0","Role":"e7db9873","chunk-34cb6d8e":"a4ed03fe","chunk-c8fd8f6a":"f3ce9305","performance":"c9c7a759","chunk-31fe34e9":"70e3a872","chunk-2d2302c4":"31d6cfe0","Updates":"b64b233a"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
